import { Decoder } from '@iotize/common/converter/api';

interface VariableConverterMap<OT, KeyType extends keyof OT> {
  converter: Decoder<Uint8Array, OT[KeyType]>;
  name: KeyType;
}

/**
 *
 * @experimental
 */
export function extractTypedDataFromRecord<
  OT extends Record<string, any>,
  K1 extends number = number,
  TNoThrow = true | false,
>(
  data: Record<K1, Uint8Array>,
  mapping: { [K2 in K1]: VariableConverterMap<OT, keyof OT> },
  allowUndefinedKeys?: TNoThrow,
) {
  // console.log('decodeDataLogPacket', meta)
  const result: Partial<OT> = {};
  // const bundleMeta: BundleConfig | undefined = meta.find(

  for (const key of Object.keys(mapping).map((key) =>
    parseInt(key, 10),
  ) as K1[]) {
    if (key in data) {
      const value: Uint8Array = data[key];
      const { name, converter } = mapping[key];
      result[name] = converter.decode(value);
    } else {
      if (!allowUndefinedKeys) {
        throw new Error(`Missing variable identifier "${key}" in data`);
      }
    }
  }
  return result as TNoThrow extends false | undefined ? OT : Partial<OT>;
}
